import { css } from '@emotion/react';
import { CSSProperties } from 'react';
import { colors } from './colors';
import { isNewUi, radius } from './ui-version';

export const transparentBgStyle: CSSProperties = {
  background: colors.surface.card,
};

/** The tint on a derived figure beside recorded ones, as the Cap Table's metric-sourced KPIs. */
export const derivedBgStyle: CSSProperties = {
  background:
    'radial-gradient(100% 204.54% at 0% 0%, rgba(234, 244, 251, 0.8) 0%, rgba(200, 209, 249, 0.32) 100%)',
};

// In the New UI a card on the page has no visible stroke: white on the grey page is enough. The
// 1px stays transparent so sizes don't change.
export const borderStyle = {
  borderRadius: radius,
  border: `1px solid ${isNewUi ? 'transparent' : colors.neutral[80]}`,
};

export const cardBorderStyles: CSSProperties = { ...borderStyle };

// A card inside a card is white on white in the New UI, so it keeps a hairline.
export const cardStyles: CSSProperties = {
  ...cardBorderStyles,
  background: colors.surface.cardNested,
  border: `1px solid ${isNewUi ? colors.border.default : colors.neutral[80]}`,
  padding: '0.5rem 1rem',
};

export const flatCardStyleNewCss = css({
  ...borderStyle,
  padding: '0.5rem 1rem',
});

export const borderedSectionCss = css({
  border: '1px solid var(--mui-colors-neutral-30)',
  borderRadius: '8px',
  padding: '1rem',
});

export const elevatedCardStyleCss = css({
  ...borderStyle,
  // The New UI is flat: surfaces are told apart by colour and hairlines, never by elevation
  boxShadow: isNewUi
    ? 'none'
    : '0px 24px 48px 0px rgba(75, 82, 93, 0.02), 0px 4px 24px 0px rgba(16, 37, 62, 0.04), 0px -4px 40px 0px rgba(255, 255, 255, 0.06)',
  padding: '0.5rem 1rem',
});

/** Text for screen readers only: the standard visually-hidden recipe (MUI's `visuallyHidden`), hence raw values. */
export const visuallyHiddenCss = css({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
});

export const baseFormInlineClassNames = 'form-control form-inline';
export const formSelectInlineClassNames = `${baseFormInlineClassNames} form-inline-select`;
export const formTextFieldInlineClassNames = `${baseFormInlineClassNames} form-inline-input`;

/**
 * Collapse AgGrid's auto-height viewport floor so populated grids hug their rows.
 * Apply only when rows exist — empty grids keep the default floor so the no-rows
 * overlay has room.
 */
export const gridHugRowsCss = css`
  .ag-layout-auto-height .ag-grid-scrolling-rows {
    min-height: 36px;
  }
`;
